const image = {
    logo7M: "/images/7m.svg",
    logoBoohawi: "/images/boohawi.svg",
    logoTopcat: "/images/topcat.svg",
    logoconvene: "/images/convene-global.svg",
}

export default image;